import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Mail: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5335 3.15833C14.3168 3.05833 14.0835 3 13.8335 3H2.1668C1.9168 3 1.68346 3.05833 1.4668 3.15833L8.00013 8.875L14.5335 3.15833Z"
      fill="currentColor"
    />
    <path
      d="M15.275 3.8418L8.33333 9.9168C8.24167 10.0001 8.125 10.0418 8 10.0418C7.875 10.0418 7.76667 10.0001 7.66667 9.9168L0.725 3.8418C0.583333 4.08346 0.5 4.3668 0.5 4.6668V11.3335C0.5 12.2501 1.25 13.0001 2.16667 13.0001H13.8333C14.75 13.0001 15.5 12.2501 15.5 11.3335V4.6668C15.5 4.3668 15.4167 4.08346 15.275 3.8418Z"
      fill="currentColor"
    />
  </svg>
);
